import { flow, Instance, SnapshotIn, SnapshotOut, types } from "mobx-state-tree";
import { serializeImportTopicsData } from "./serializers";
import { deserializeTopics } from "./deserializer";
import { TopicsApi } from "../../../api/questions/TopicsApi";
import { PageQuery } from "../../../api/questions/typings";
import { snackbarStore } from "../../ui/SnackbarStore";

export interface ImportTopicData {
    filename: string;
}

export const TopicModel = types.model({
    created_at: types.string,
    id: types.identifier,
    theory: types.maybeNull(types.array(types.model({
        file: types.string,
        name: types.string,
        size: types.number,
        type: types.string
    }))),
    title: types.string,
    updated_at: types.maybeNull(types.string),
    order: types.number,
});

export const TopicsModel = types
    .model({
        topics: types.array(TopicModel),
        page: types.model({
            current_page: types.maybe(types.number),
            from: types.maybe(types.number),
            last_page: types.maybe(types.number),
            per_page: types.maybe(types.number),
            to: types.maybe(types.number),
            total: types.maybe(types.number),
        })
    })
    .actions((self) => {
        const importTopics = flow(function* (filename: ImportTopicData) {
            const serializedImportTopicData = serializeImportTopicsData(filename);
            const response = yield TopicsApi.importTopics(serializedImportTopicData);
            self.topics = deserializeTopics(response);
            snackbarStore.notifySuccess(`Импорт завершен! Всего тем в базе: ${self.topics.length}`);
        });

        const getTopics = flow(function* (query: PageQuery = {}) {
            const response = yield TopicsApi.getTopics(query);
            const { page } = response.meta;
            if (page) {
                self.page = response.meta.page;
            }
            self.topics = deserializeTopics(response);
        });

        return {
            getTopics,
            importTopics,
        };
    })
    .views((self) => ({
        get getTopicsTableData() {
            return self.topics.map(({ id, title, order }) => ({ id, title, order }))
        },
        get getTopicsData() {
            return self.topics;
        }
    }));

export interface Topic extends Instance<typeof TopicModel> {
}

export interface TopicSnapshotIn extends SnapshotIn<typeof TopicModel> {
}

export interface TopicSnapshotOut extends SnapshotOut<typeof TopicModel> {
}

export interface Topics extends Instance<typeof TopicsModel> {
}
